export var PageIdentifierType = {
    unknown: 'unknown',
    tpaPageId: 'tpaPageId',
    pageId: 'pageId',
};
//# sourceMappingURL=types.js.map